import React from 'react';

const DEFAULT_COLORS = ['red', 'amber', 'green'];

const RagBadgeField = ({ colors, value, onChange, disabled = false }) => {
  const available = colors?.length ? colors : DEFAULT_COLORS;
  const selected = (value ?? '').toLowerCase();

  return (
    <div className={`rag-badge-field${selected ? ' rag-badge-field--answered' : ''}`}>
      {available.map((color) => {
        const key = String(color).toLowerCase();
        const isSelected = key === selected;

        return (
          <button
            key={key}
            type="button"
            disabled={disabled}
            aria-label={key}
            aria-pressed={isSelected}
            className={[
              'rag-badge-field__swatch',
              `rag-badge-field__swatch--${key}`,
              isSelected ? 'rag-badge-field__swatch--selected' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            onClick={() => onChange?.(isSelected ? undefined : key)}
          />
        );
      })}
    </div>
  );
};

export default RagBadgeField;
